export { default } from "./UserDashboard.gql";
